import React, { FC, useState } from 'react';
import { ReactComponent as PushNotificationIcon } from 'assets/icons/push-notification-modal-icon.svg';
import { toast } from 'react-toastify';
import { BaseModal, Button, Input, ToastMessage } from '@cokitchen/cokitchen-components';
import { OrderType } from 'models/order.model';
import { apiService } from 'utils/api';

interface PushNotificationModalProps {
  show: boolean;
  onClose: () => void;
  order: OrderType;
}

interface PushNotificationFooterProps {
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const PushNotificationFooter: FC<PushNotificationFooterProps> = ({
  onCancel,
  onConfirm,
  loading
}) => (
  <div className='grid grid-cols-2 gap-x-4'>
    <Button small color='primary' variant='outline' className='mx-auto' onClick={onCancel}>
      Cancel
    </Button>
    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      loading={loading}
      onClick={onConfirm}>
      Confirm
    </Button>
  </div>
);

const PushNotificationModal: FC<PushNotificationModalProps> = ({ show, onClose, order }) => {
  const [selectedReason, setSelectedReason] = useState(1);
  const [loading, setLoading] = useState(false);
  const pushNotification = async () => {
    try {
      setLoading(true);
      await apiService.post('logistics/order/push-notification', {
        data: {
          order_id: order.id,
          message_type: selectedReason
        },
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });
      toast(<ToastMessage type='success' message='Notification sent successfully' />);
      onClose();
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };
  return (
    <BaseModal
      isOpen={show}
      title='Push Notification'
      description='Send a text to the user for updates on their order'
      titleIcon={<PushNotificationIcon />}
      titleIconColor='info'
      onRequestClose={onClose}
      footer={
        <PushNotificationFooter loading={loading} onCancel={onClose} onConfirm={pushNotification} />
      }>
      <div className='flex gap-4 justify-between'>
        <Input
          checked={selectedReason === 1}
          label='Order is running late'
          onChange={() => setSelectedReason(1)}
          type='radio'
          name='pushNotifications'
        />
        <Input
          type='radio'
          checked={selectedReason === 2}
          onChange={() => setSelectedReason(2)}
          label='You have to pickup yourself'
          name='pushNotifications'
        />
      </div>
    </BaseModal>
  );
};

export default PushNotificationModal;
